const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ItemAcceptanceCancellationQueryURL: any = {
    GetItemAcceptancePageData: Backofficebff + '/v1/productacceptance/get',
    GetMatchingSetByModelOption: Backofficebff + '/v1/productacceptance/matching-set',
    GetItemCancellationPageData: Backofficebff + '/v1/shotcancellation/get',
    QueryCancelledShots: Backofficebff + '/v1/shotcancellation/cancelled',
};
